import BasePage from "pages/base_page";
import renderEditorialMenu from "lib/renderEditorialMenu";

const EDITORIAL_ACTIONS_MENU_PATH = "/editorial/actions_menu/partners/:partner_id";

export default class PartnerPage extends BasePage {
  initialize(options) {
    super.initialize(options);

    renderEditorialMenu(EDITORIAL_ACTIONS_MENU_PATH.replace(":partner_id", options.id));
  }
}
